import script from "./BaseInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=97d81384&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d81384"]])

export default __exports__